import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "container" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "sub_top" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("스마트 안전게이트"),
  /*#__PURE__*/_createElementVNode("span", null, "IoT Safety Gate")
], -1)

import bg_sub_top from "@/assets/images/pages/bg_sub_top.jpg";
import m_bg_sub_top from "@/assets/images/pages/m_bg_sub_top.jpg";
export default {
  setup(__props) {


return (_ctx, _cache) => {
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _unref(bg_sub_top),
          alt: "PC 배경이미지",
          class: "pc"
        }, null, 8, _hoisted_4),
        _createElementVNode("img", {
          src: _unref(m_bg_sub_top),
          alt: "모바일 배경이미지",
          class: "mw"
        }, null, 8, _hoisted_5),
        _hoisted_6
      ]),
      _createVNode(_component_router_view)
    ])
  ]))
}
}

}